import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import Translation from '../../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../../v2/selectors/isUsingArtemisStyles';
import useStyles from './SocialChannelButton.styles';

export function SocialChannelButton(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <Button
      id={`referralsSocialSharing_socialButton-${props.channelName}`}
      className={classes.socialChannelButton}
      name={`referralsSocialSharing_socialButton-${props.channelName}`}
      onClick={props.action}
    >
      <img className={classes.icon} alt="" src={props.icon} />
      <div className={classes.text}>
        <Translation>{`referralsSocialSharing.channel.${props.channelName}`}</Translation>
      </div>
    
    </Button>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

SocialChannelButton.propTypes = {
  channelName: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(SocialChannelButton);
